import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "px-7 py-5" }
const _hoisted_8 = { class: "row mb-8" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = ["label"]
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "row mb-8"
}
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = ["label"]
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "col-6"
}
const _hoisted_18 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_19 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "badge badge-light-success fs-6" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "text-center py-10 text-muted fs-6"
}
const _hoisted_25 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  type: "button",
  class: "btn btn-light-success btn-sm me-2"
}
const _hoisted_28 = { class: "svg-icon svg-icon-2" }
const _hoisted_29 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_30 = { class: "indicator-label" }
const _hoisted_31 = { class: "indicator-progress" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_vue3_json_excel = _resolveComponent("vue3-json-excel")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'reports'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('AdsPerQuarterReports')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _withModifiers(_ctx.onSubmitCreate, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedItems.areaIds,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.areaIds) = $event)),
                        mode: "tags",
                        required: false,
                        label: "titleAr",
                        trackBy: "titleAr",
                        searchable: true,
                        canDeselect: true,
                        options: _ctx.areas,
                        placeholder: _ctx.translate('selectAreas'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm form-select-solid",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.adTypeId) = $event))
                      }, [
                        _createElementVNode("option", {
                          label: _ctx.translate('selectAdTypes'),
                          value: ""
                        }, null, 8, _hoisted_11),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adTypes, (adType) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: adType.id,
                            value: adType.id
                          }, _toDisplayString(adType.titleAr), 9, _hoisted_12))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.selectedItems.adTypeId]
                      ])
                    ])
                  ]),
                  (
                _ctx.propertyTypesCategories && _ctx.propertyTypesCategories.length > 0
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select form-select-sm form-select-solid",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.propertyTypesCategoryId) = $event))
                          }, [
                            _createElementVNode("option", {
                              label: _ctx.translate('selectPropertyTypesCategories'),
                              value: ""
                            }, null, 8, _hoisted_15),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyTypesCategories, (propertyTypesCategory) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: propertyTypesCategory.id,
                                value: propertyTypesCategory.id
                              }, _toDisplayString(propertyTypesCategory.titleAr), 9, _hoisted_16))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.selectedItems.propertyTypesCategoryId]
                          ])
                        ]),
                        (_ctx.propertyTypes && _ctx.propertyTypes.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_Multiselect, {
                                modelValue: _ctx.selectedItems.propertyTypeIds,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedItems.propertyTypeIds) = $event)),
                                mode: "tags",
                                required: false,
                                label: "titleAr",
                                trackBy: "titleAr",
                                searchable: true,
                                canDeselect: true,
                                options: _ctx.propertyTypes,
                                placeholder: _ctx.translate('selectPropertyType'),
                                valueProp: "id",
                                noResultsText: _ctx.translate('noResultsFound')
                              }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showExportBtn && _ctx.data && _ctx.data.data && _ctx.data.data.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.translate('NumOfData')) + ": " + _toDisplayString(_ctx.data.data.length), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                  : _createCommentVNode("", true),
                (
              _ctx.hasQueried &&
              !_ctx.isLoading &&
              (!_ctx.data || !_ctx.data.data || _ctx.data.data.length === 0)
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.translate('noDataFound')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_25, [
                (_ctx.showExportBtn && _ctx.data && _ctx.data.data && _ctx.data.data.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                      _createVNode(_component_vue3_json_excel, {
                        "json-data": _ctx.data.data,
                        fields: _ctx.excelHeader,
                        header: _ctx.excelHeaderRows,
                        worksheet: "Ads Per Quarter WorkSheet",
                        name: 
                'Ads_Per_Quarter' +
                'Reports_' +
                new Date().toISOString().slice(0, 10) +
                '.xls'
              
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", _hoisted_27, [
                            _createElementVNode("span", _hoisted_28, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil009.svg" })
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.translate('export')), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["json-data", "fields", "header", "name"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light-danger btn-sm me-3",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
                }, _toDisplayString(_ctx.translate('resetFilters')), 1),
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('back')), 1),
                _createElementVNode("button", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.translate('query')), 1),
                  _createElementVNode("span", _hoisted_31, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_32
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ]))
    : _createCommentVNode("", true)
}